// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_XvzN4","header":"header_CuEH4","content":"content_GhvX-","footer":"footer_7mC4g"};